
import React, { useEffect, useState } from "react";
import "./AddPost.css";
import { useGlobalContext } from "../../context";
import chunk from "chunk";
import Pagination from "../../Components/Pagination/Pagination";
import { getAllClients } from "../../api";

function AddPostTable({ activeCategory, setCheckinClients, country }) {
            
    const {
        showUsers,
        setShowUsers,
        setChunkData,
        tableData,
        chunkData,
        setTableData,
        openCompleted
    } = useGlobalContext()

    const [checkAll, setChekAll] = useState(false);
    const [allClients, setAllClients] = useState([]);

    const getClients = async () => {
        let clients = await getAllClients();
        if (clients.data) {
            setAllClients(clients.data.map(item => {
                return { ...item, active: false };
            }));
        }
    }

    useEffect(() => {
        getClients();
    }, [])

    useEffect(() => {
        if (country) {
            const countryClients = allClients.filter(item => item.country === country);
            const activeClientsThisCountry = countryClients.filter(item => item.active);
            setShowUsers(countryClients);
            setCheckinClients(activeClientsThisCountry);
        }
        else {
            setShowUsers(allClients.filter(item => item.category.replaceAll("_", " ").toUpperCase() === activeCategory));
            const activeClients = allClients.filter(item => item.active);
            setCheckinClients(activeClients);
        }
    }, [allClients, activeCategory, country])

    const dateUpdate = (date) => {
        return new Date(date).toLocaleDateString("en-US", {
            month: "short", 
            day: "numeric", 
            year: "numeric", 
            hour: "numeric", 
            minute: "numeric"
        })
    }
    
    const checkUser = (user) => {
        setAllClients(allClients => allClients.map(item => item.id === user.id ? { ...item, active: !item.active } : { ...item }));
    }

    const checkinAll = (e) => {
        for (let i = 0; i < showUsers.length; i++) {
            setAllClients(allClients => allClients.map(item => {
                if (item.id === showUsers[i].id) {
                    return { ...item, active: e.target.checked };
                }
                else {
                    return { ...item };
                }
            }))
        }
    }

    useEffect(() => {
        setChunkData(chunk(showUsers,100));
        const activeClients = showUsers.filter(item => item.active === true);
        if (activeClients.length < showUsers.length) {
            setChekAll(false);
        }
        else if (showUsers.length === 0) {
            setChekAll(false);
        }
        else {
            setChekAll(true);
        }
    }, [showUsers])

    useEffect(() => {
        if (openCompleted) {
            setAllClients(allClients => allClients.map(client => { return { ...client, active: false } }));
        }
    }, [openCompleted]);

    return(
        <div className = "AddPostTableComponentBox">
            <div className = "AddPostTable">
                <div className = "AddPostTableRowBox">
                    <span className = "addPostClientID addPostHeaderText">ID</span>
                    <span className = "addPostCheckBox addPostHeaderText"></span>
                    <span className = "addPostFullName addPostHeaderText">FULL NAME</span>
                    <span className = "addPostProfileType addPostHeaderText">PROFILE TYPE</span>
                    <span className = "addPostFbID addPostHeaderText">FACEBOOK ID</span>
                    <span className = "addPostInstaId addPostHeaderText">INSTAGRAM ID</span>
                    <span className = "addPostCategory addPostHeaderText">CATEGORY</span>
                    <span className = "addPostDate addPostHeaderText">DATE CREATED</span>
                    <span className = "addPostDate addPostHeaderText">ADDITIONAL NOTES</span>
                </div>
                <div className = "AddPostTableRowBox">
                    <span className = "addPostClientID">All</span>
                    <span className = "addPostCheckBox">
                         <label className = "checkboxLabel">
                              <input 
                                  type = 'checkbox' 
                                  checked = { checkAll }
                                  onChange = {e => {
                                      setChekAll(e.target.checked);
                                      checkinAll(e);
                                  }}
                              />
                              <span></span>
                         </label>
                    </span>
                    <span className = "addPostFullName"></span>
                    <span className = "addPostProfileType"></span>
                    <span className = "addPostFbID"></span>
                    <span className = "addPostInstaId"></span>
                    <span className = "addPostCategory"></span>
                    <span className = "addPostDate"></span>
                    <span className = "addPostDate"></span>
                </div>
                {
                    tableData && tableData.map((item,index) => 
                        <div 
                            className = "AddPostTableRowBox" 
                            key = { item.id }
                        >
                            <span className = "addPostClientID">{ index+1 }</span>
                            <span className = "addPostCheckBox">
                                 <label className = "checkboxLabel">
                                     <input 
                                         type = 'checkbox' 
                                         onChange = { checkUser.bind(this,item) }
                                         checked = { item.active }
                                     />
                                    <span></span>
                                </label>
                            </span>
                            <span className = "addPostFullName">{ item.fullName }</span>
                            <span className = "addPostProfileType">{ item.subscription.replaceAll("_", " and ").toLowerCase() }</span>
                            <span className = "addPostFbID">{ item.facebookProfileId }</span>
                            <span className = "addPostInstaId">{ item.instagramProfileId ? item.instagramProfileId : "-" }</span>
                            <span className = "addPostCategory">{ item.category.replaceAll("_", " ").toLowerCase() }</span>
                            <span className = "addPostDate">{ dateUpdate(item.creationDate) }</span>
                            <span className = "addPostDate">{ item.additionalNotes ? item.additionalNotes : "-" }</span>
                        </div> 
                    )
                }
            </div>
            <Pagination 
                chunkData = {chunkData} 
                setTableData = {setTableData}
            />
        </div>
    )
}

export default AddPostTable  

